var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"nav-bar"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Games")]),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }